import React, {useEffect, useState} from "react";
import {InputTextMaskOld} from "../InputTextMaskOld";
import {FieldAttributes} from "formik";
import plate_number_image from "../../../images/plate_number_image.png";
import "./index.scss"
import {IconButton, InputAdornment} from "@material-ui/core";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import {IFormattedResponse} from "../../../model/parametrizedResponse";

interface PlateNumberInput {
    onSearchListener?: () => void;
    small?: boolean;
    label?: string;
    withoutQ?: boolean;
    errorMessage?: string;   
    error?:boolean;
    backEndName?: string;
    setFieldToUpdate?: (fieldToUpdate: any) => void;
    formatResponse?: (obj: any) => IFormattedResponse;
}

export const PlateNumberInputOld = (props: FieldAttributes<PlateNumberInput>) => {
    const {name, errorMessage, error, backEndName, setFieldToUpdate, formatResponse} = props;
    const {withoutQ, small, onSearchListener} = props;

    const [complete, setComplete] = useState(false);

    let formatCharts = withoutQ ? {
        "a": "[A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,R,S,T,U,V,W,X,Y,Z,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,r,s,t,u,v,w,x,y,z,xА-ЯІа-яі]",
        "9": "[0-9]"
    } : {
        "a": "[A-ZА-ЯІa-zа-яі]",
        "9": "[0-9]"
    };

    const translitMap: Record<string, string> = {
        "A": "А",
        "B": "В",
        "C": "С",
        "E": "Е",
        "H": "Н",
        "I": "І",
        "K": "К",
        "M": "М",
        "O": "О",
        "P": "Р",
        "T": "Т",
        "Y": "У",
        "X": "Х"
    };

    function replace(value: string) {
        let result = value;

        for (let i = 0; i < value.length; i++) {
            Object.keys(translitMap).forEach(latinSymbol => {
                if (value.charAt(i) === latinSymbol) {
                    result = result.substring(0, i) + translitMap[latinSymbol] + value.substring(i + 1);
                }
            })
        }

        return result;
    }

    const className = classNames({
        "plate-number-input": true,
        "plate-number-input_small": small
    });

    useEffect(() => {
        if( props.defaultValue && typeof props.defaultValue === 'string' && props.defaultValue.length === 8 ){
            setComplete(true)
        }
    }, [])

    return (
        <div className="plate-number">
        <div className={`${className}`}>
            <div className={"plate-number-input__image"}>
                <img style={{borderTopLeftRadius: "4px", borderBottomLeftRadius: "4px"}}
                     src={plate_number_image} alt={''}/>
            </div>
            <div className={"plate-number-input__input"}>
                <InputTextMaskOld name={name}
                               error={false}
                               backEndName={backEndName}
                               setFieldToUpdate={setFieldToUpdate}
                               formatResponse={formatResponse}
                               onValueChange={(value: string) => {
                                   if (value.length === 8) {
                                       setComplete(true);
                                   } else {
                                       setComplete(false);
                                   }
                               }}
                               beforeChange={(value: string) => {
                                   return replace(value);
                               }}
                               formatChars={formatCharts}
                               mask={"aa 9999 aa"}
                               toUpperCase={true}
                               endAdornment={complete && onSearchListener && (
                                   <InputAdornment position="end">
                                       <IconButton onClick={() => {
                                           onSearchListener();
                                       }}>
                                           <FontAwesomeIcon icon={faArrowRight as any} className='plate-number-input__input-svg'/>
                                       </IconButton>
                                   </InputAdornment>
                               )}
                               placeholder={'АА 1234 АА'}/>
            </div>
        </div>
            {error && <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error MuiFormHelperText-filled">
                {errorMessage}
            </p>}
        </div>
    )
};